import api from "../axios";


/*
|--------------------------------------------------------------------------
| GET WEBSITE CATEGORIES
|--------------------------------------------------------------------------
|
| Backend:
| GET /api/website-products/categories
|
| Public endpoint — no authentication required.
|--------------------------------------------------------------------------
*/

export const getWebsiteCategories = async () => {

  const response =
    await api.get(
      "/website-products/categories"
    );

  return response.data;

};


/*
|--------------------------------------------------------------------------
| GET WEBSITE PRODUCTS
|--------------------------------------------------------------------------
|
| Backend:
| GET /api/website-products
|
| Optional:
| ?search=crm
| ?categoryId=...
| ?page=1
| ?limit=12
|
| Public endpoint — no authentication required.
|--------------------------------------------------------------------------
*/

export const getWebsiteProducts = async ({
  search = "",
  categoryId = "",
  page = 1,
  limit = 12,
} = {}) => {

  const response =
    await api.get(
      "/website-products",
      {
        params: {

          search:
            search.trim() || undefined,

          categoryId:
            categoryId || undefined,

          page,

          limit,

        },
      }
    );

  return response.data;

};